import ContentTile from '../content/ContentTile'
import { type Theme } from '#app/utils/providers/themeProvider'
import placeholder from '#images/link-placeholder.jpg'
import placeholderDark from '#images/link-placeholder-dark.jpg'

const placeholderThumbnail = {
	name: 'placeholder',
	image: placeholder,
	imageDark: placeholderDark,
}

const mediaThumbnails = [
	{
		name: 'artnet',
		hostname: 'artnet.com',
		image: '/mediaThumbnails/artnet.jpg',
	},
	{
		name: 'artnews',
		hostname: 'artnews.com',
		image: '/mediaThumbnails/artnews.jpg',
	},
	{
		name: 'exchangeart',
		hostname: 'exchange.art',
		image: '/mediaThumbnails/exchangeart.jpg',
		imageDark: '/mediaThumbnails/exchangeartDark.jpg',
	},
	{
		name: 'christies',
		hostname: 'christies.com',
		image: '/mediaThumbnails/christies.jpg',
	},
	{
		name: 'crystalBridges',
		hostname: 'crystalbridges.org',
		image: '/mediaThumbnails/crystalBridges.jpg',
	},
	{
		name: 'forbes',
		hostname: 'forbes.com',
		image: '/mediaThumbnails/forbes.jpg',
	},
	{
		name: 'instagram',
		hostname: 'instagram.com',
		image: '/mediaThumbnails/instagram.jpg',
		imageDark: '/mediaThumbnails/instagramDark.jpg',
	},
	{
		name: 'medium',
		hostname: 'medium.com',
		image: '/mediaThumbnails/medium.jpg',
	},
	{
		name: 'mPlus',
		hostname: ['mPlus.org', 'mplus.org', 'mplus.org.hk', 'www.mplus.org.hk'],
		image: '/mediaThumbnails/mPlus.jpg',
	},
	{
		name: 'nftCulture',
		hostname: 'nftculture.com',
		image: '/mediaThumbnails/nftCulture.jpg',
	},
	{
		name: 'nftNow',
		hostname: 'nftnow.com',
		image: '/mediaThumbnails/nftNow.jpg',
	},
	{
		name: 'nyt',
		hostname: ['nytimes.com', 'nyt.com', 'nyt.net'],
		image: '/mediaThumbnails/nyt.jpg',
	},
	{
		name: 'sothebys',
		hostname: 'sothebys.com',
		image: '/mediaThumbnails/sothebys.jpg',
	},
	{
		name: 'x',
		hostname: ['x.com', 'twitter.com'],
		image: '/mediaThumbnails/x.jpg',
		imageDark: '/mediaThumbnails/xDark.jpg',
	},
	{
		name: 'youtube',
		hostname: ['youtube.com', 'youtu.be'],
		image: '/mediaThumbnails/youtube.jpg',
		imageDark: '/mediaThumbnails/youtubeDark.jpg',
	},
]

const getMediaThumbnail = (url: string) => {
	const isURL = URL.canParse(url)
	if (isURL) {
		const hostname = new URL(url).hostname
		const matchingEntry = mediaThumbnails.find(media => {
			if (Array.isArray(media.hostname)) {
				return media.hostname.find(mediaHost => hostname.includes(mediaHost))
			} else {
				return hostname.includes(media.hostname)
			}
		})
		return matchingEntry || placeholderThumbnail
	}

	return placeholderThumbnail
}

const MediaCitation = ({
	metadata,
	theme,
}: {
	theme?: Theme | undefined
	metadata: any
}) => {
	let descriptionString = ''
	if (metadata.properties.date) {
		descriptionString += `${metadata.properties.date} `
	}
	if (metadata.properties.publisher) {
		descriptionString += `• ${metadata.properties.publisher}`
	}
	if (metadata.properties.author) {
		descriptionString += `• by ${metadata.properties.author}`
	}

	const mediaThumbnail = getMediaThumbnail(metadata.properties.url)
	// @ts-ignore
	const thumbnailImage: string =
		theme && theme === 'dark' && mediaThumbnail.imageDark
			? mediaThumbnail.imageDark
			: mediaThumbnail.image

	return (
		<a href={metadata.properties.url} target="_blank" rel="noreferrer">
			<ContentTile
				title={metadata.properties.title}
				description={descriptionString}
				image={thumbnailImage}
				variant="art"
				showCaret={true}
				showBorder={true}
			/>
		</a>
	)
}

export default MediaCitation
